<template>
  <div class="">

    <div class="col-12">

      <h5 class="text-center">اشتراک کاربر</h5>

      <div class="row my-4">

        <div class="col-lg-6">
          <span class="">شناسه اشتراک(غیرالزامی)</span>
          <input v-model="subscription_name" type="text" class="form-control ">
        </div>

        <div class="col-lg-6">
          <div class="">
            <span>انتخاب کاربر

            <span class="text-primary" v-if="selectedUser">({{ selectedUser.name }} {{ selectedUser.last_name }})</span>

            </span>

          </div>
          <form @submit.prevent="loadUsers">
            <div class="row justify-content-center">
              <b-form-input
                  v-model="userSearchWord"
                  class="col-8"
                  placeholder="نام، نام خانوادگی، شماره تلفن"
              ></b-form-input>

              <b-button
                  class="col-3 mr-1"
                  @click="loadUsers"
                  variant="primary">
                جستجو
              </b-button>
            </div>

            <div class="choose-item-section-users my-1" v-if="users.length > 0">
              <div v-for="user in users" class="cursor-pointer choose-item py-2 "
                   @click="selectedUserItem(user)">
                {{ user.name }} {{ user.last_name }}
              </div>
            </div>

          </form>
        </div>


        <div class="col-lg-12">
          <div class="my-3">
            <span class="d-block">انتخاب اشتراک</span>
            <span class="btn btn-primary d-inline-block rounded-pill  selected-item mr-2"
                  v-for="(item,index) in selectedProduct"  @dblclick="deleteSubscriptionItem(index)" >{{ item.name }}</span>
          </div>
          <form @submit.prevent="loadProducts">
            <div class="row justify-content-center">
              <b-form-input
                  v-model="productSearchWord"
                  class="col-8"
                  placeholder="نام محصول"
              ></b-form-input>

              <b-button
                  class="col-3 mr-1"
                  @click="loadProducts"
                  variant="primary">
                جستجو
              </b-button>
            </div>

            <div class="choose-item-section my-1">
              <div v-for="product in products" class="cursor-pointer choose-item py-2 "

                   @click="selectedProductItem(product)">
                {{ product.name }}
              </div>
            </div>

          </form>
        </div>


      </div>
    </div>

    <hr>


    <div class="col-12 mt-3 ">
      <div class="row justify-content-center">
        <button class="btn btn-primary rounded-pill px-5" @click="manuallyChargeSubscription()">ثبت</button>
      </div>
    </div>


  </div>
</template>

<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "CreateManualSubscriptionCharge",
  data() {
    return {
      productSearchWord: '',
      userSearchWord: '',
      users: [],
      products: [],
      selectedUser: null,
      selectedProduct: [],
      subscription_name: "",
    }
  },
  methods: {
    manuallyChargeSubscription() {

      let form = {
        user_id: this.selectedUser.id,
        product_id: this.selectedProduct.map(item => item.id),
        subscription_name: this.subscription_name
      }

      this.$store.dispatch('SubscriptionCharge/manuallyChargeSubscription', form).then(res => {
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        this.$emit('loadItems', true)
      })


    },
    loadProducts() {
      this.$store.commit('Product/setFilters', {key: 'search', value: this.productSearchWord})
      let req = this.$store.dispatch('Product/getProductsWithSubscription')

      req.then(res => {
        this.products = res.data.data.data
      })
    },
    loadUsers() {
      this.$store.commit('User/setFilters', {key: 'search', value: this.userSearchWord})
      let req = this.$store.dispatch('User/getPersonsWithoutState')
      req.then(res => {
        this.users = res.data.data.data
      })
    },
    selectedUserItem(item) {
      this.selectedUser = item
      this.users = []
    },
    selectedProductItem(item) {
      let productIds = this.selectedProduct.map(item => item.id)
      if (productIds.indexOf(item.id) > -1) {
        toast('خطا', 'ایتم موجود است', 'danger')
        return false
      }
      this.selectedProduct.push(item)
    },
    deleteSubscriptionItem(index) {
      this.selectedProduct.splice(index, 1)
    }
  },
  mounted() {
    this.loadProducts()
  }
}
</script>

<style scoped>
.choose-item-section {
  overflow: auto;
  height: 310px;
  background: #f5f5f5;
  z-index: 1;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}

.choose-item-section-users{
  overflow: auto;
  height: 310px;
  background: #f5f5f5;
  z-index: 1;
  padding: 5px;
  height: 110px;
  position: absolute;
  width: 93%;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}


.selected-item {
  font-size: 13px;
  margin: 5px;
}

.choose-item:hover {
  background: var(--primary);
  color: white;
}

</style>